import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import Component from "components/Component";
import PrettyNumberTextField from "components/common/PrettyNumberTextField";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as exposureActions from "store/actions/input/exposure/exposureActions";
import * as exposureSelectors from "store/selectors/input/exposure/exposureSelectors";
import * as programSelectors from "store/selectors/input/program/programSelectors";

const StandaloneExposure = ({ showAllConfiguredExposures = true } = {}) => {
  const exposureListSelector = useMemo(
    () => (state) =>
      showAllConfiguredExposures
        ? exposureSelectors.getExposureListExcludingRemoved(state)
        : exposureSelectors.getExposureList(state),
    [showAllConfiguredExposures]
  );
  const exposures = useSelector(exposureListSelector);
  const data = useSelector(exposureSelectors.getData);
  const primaryExposure = useSelector(exposureSelectors.getPrimaryExposure);
  const inceptionYear = useSelector(programSelectors.getInceptionYear);
  const dispatch = useDispatch();

  return (
    <Component
      title={"Exposure"}
      subtitle={"The main exposure metric driving risk and price."}
    >
      <Stack gap={2}>
        <FormControl variant={"filled"} fullWidth>
          <InputLabel shrink>{"Exposure Metric"}</InputLabel>
          <Select
            value={primaryExposure ?? ""}
            onChange={(e) => {
              dispatch(exposureActions.updatePrimaryExposure(e.target.value));
            }}
          >
            {(exposures ?? []).map((exposure) => (
              <MenuItem key={exposure.key} value={exposure.key}>
                {exposure.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {primaryExposure != null && (
          <PrettyNumberTextField
            value={data?.[inceptionYear]?.[primaryExposure]}
            onChangeNumber={(value) => {
              dispatch(
                exposureActions.updateValue(
                  inceptionYear,
                  primaryExposure,
                  value
                )
              );
            }}
            label={"Value"}
            variant={"filled"}
            InputLabelProps={{ shrink: true }}
            disabled={inceptionYear == null}
            placeholder={
              inceptionYear == null ? "Please set an inception date" : null
            }
          />
        )}
      </Stack>
    </Component>
  );
};

export default StandaloneExposure;
